import React from 'react'
import moment from 'moment'
import { ToolTip } from '@driftt/tide-core'

import './style.css'

export const Columns = [
  {
    label: 'List Name',
    value: 'userListName',
    sortable: false,
    width: '300px',
    className: 'pardot-import-logs--table-header--sticky'
  },
  {
    label: 'List type',
    value: 'listType',
    sortable: false,
    className: 'pardot-import-logs--table-header--sticky'
  },
  {
    label: 'Import created',
    value: 'createdAt',
    sortable: false,
    className: 'pardot-import-logs--table-header--sticky'
  },
  {
    label: <ToolTip component={'Contacts added to this segment made from this Pardot list'} flow="down">Added to segment</ToolTip>,
    value: 'numberAdded',
    sortable: false,
    className: 'pardot-import-logs--table-header--sticky'
  },
  {
    label: <ToolTip component={'Contacts removed from the segment made from this Pardot list'} flow="down">Removed from segment</ToolTip>,
    value: 'numberRemoved',
    sortable: false,
    className: 'pardot-import-logs--table-header--sticky'
  },
  {
    label: '',
    value: '',
    sortable: false,
    width: '100px',
    className: 'marketo-import-logs--table-header--sticky'
  }
]

export const RowFormatter = (errorEntry) => {
  const listType = errorEntry.listType === 'DYNAMIC' ? 'Dynamic list ⚡️' : 'Static list'

  return {
    data: [
      {content: errorEntry.userListName},
      {content: listType },
      {content: moment(errorEntry.createdAt).format('MM/DD/YYYY')},
      {content: errorEntry.numberAdded},
      {content: errorEntry.numberRemoved},
    ]
  }
}
